import script from "./PatientRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientRecords.vue?vue&type=script&setup=true&lang=js"

import "./PatientRecords.vue?vue&type=style&index=0&id=05fdcf98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fdcf98"]])

export default __exports__